// @core/api/endpoints/license/list_licenses.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLicensesResponse,
} from '../../../types/license';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/license';

/**
 * List licenses
 * Returns a paginated list of licenses. On master: all issued licenses. On local: only the license for this platform instance.
 */
export async function ListLicenses(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLicensesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses`;
  const requestOptions = options;
  return client.get<ListLicensesResponse>(requestPath, { ...requestOptions, params });
}
